const state = {
	loadingState: false, // loadin加载动画状态
	goodsNavState: true, // nav导航栏状态
	orderType: '' // 订单状态
}
export default state


// WEBPACK FOOTER //
// ./src/store/state.js